import React from 'react'
import style from "./claim.module.css"

export const Modal = ({setOpen}) => {

    const handaleClick = (e)=>{
        const yes = [...e.target.classList].includes("outterDiv")
        if(!yes) return;
        setOpen(false)
    }
    return (
        <div className={style.modal+' d-flex justify-content-center align-items-center position-fixed top-0 w-100 h-100 left-0 outterDiv'} style={{zIndex:"222"}} onClick={handaleClick}>
            <div className='p-3'>
                <h3 className='text-center'>Claim Rewards</h3>
                <div className={style.reward+" d-flex flex-column justify-content-center align-items-center"}>
                    <span>430.20</span>
                    <p className='text-center fw-semibold'>Available to Claim</p>
                </div>
                <div className={style.inputDiv}>
                   <input type="text" placeholder='Enter your wallet address' /> 
                </div>
                <div className='d-flex gap-3 mt-3'>
                    <button className='btn2 w-50 py-2 bg-transparent' onClick={()=>{setOpen(false)}}>Cancel</button>
                    <button className='btn1 w-50 py-2'>Submiit</button>
                </div>
            </div>
        </div>
    )
}
